// Site environment (dev/qa/prod...) that will appear on the main page.
// export const env = 'DEV';
export const env = 'QA';

// API host url:
// export const apiHost = 'http://localhost:8080';
export const apiHost = 'https://tkk-api-qa.taiwankk.com';
